import { HttpApiError, HttpApiGroup } from "@effect/platform";
import {
  automationExecutionSchema,
  type AutomationExecution,
} from "@redotech/redo-flows-common/automation-execution-definition";
import { ParseResult, Schema } from "effect";

import { endpoint } from "../auth/endpoint";
import { DatabaseError, DataIntegrityError } from "../auth/errors";
import { coerceDates } from "../schema/helpers";

// eslint-disable-next-line @redotech/no-re-exports -- TODO: remove re-export, update all import sites
export type { AutomationExecution as AutomationExecutionResponse } from "@redotech/redo-flows-common/automation-execution-definition";

const AutomationExecutionEffectSchema: Schema.Schema<
  AutomationExecution,
  unknown,
  never
> = Schema.transformOrFail(
  Schema.Unknown,
  Schema.Unknown as Schema.Schema<AutomationExecution, AutomationExecution>,
  {
    strict: true,
    decode: (input, _, ast) => {
      const coerced = coerceDates(input);
      const result = automationExecutionSchema.safeParse(coerced);
      if (result.success) {
        return ParseResult.succeed(result.data);
      }
      return ParseResult.fail(
        new ParseResult.Type(
          ast,
          input,
          result.error.issues.map((i) => i.message).join("; "),
        ),
      );
    },
    encode: ParseResult.succeed,
  },
);

export const AutomationExecutionGroup = HttpApiGroup.make("automationExecution")
  .add(
    endpoint.merchant
      .get("getByWorkflowId", "/automation-executions")
      .setUrlParams(Schema.Struct({ workflowId: Schema.String }))
      .addSuccess(Schema.NullOr(AutomationExecutionEffectSchema))
      .addError(HttpApiError.Forbidden)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .prefix("/api");
